import React from "react";
import './style.scss';

const NewBalance608 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 590.85 288.95">
    <title>new-balance-608</title>
    <path
      d="M459.07,558.4c.06-.29-.1.51-.32,1.66l-7.68,1-2.69-5-1.7,5-6.77.85c-.71-1.82-1.34-3.45-2-5.08l-1.13.19c-.36,1.68-.71,3.36-1.16,5.49H400.33c-.44-1.34-1-3-1.55-4.72l-1.08.07-1.63,5.24h-6.9l-2.41-6.23c-1.69,2.52-2.48,5-4.08,5.75-2.08,1-4.8.49-7.44.65L373.86,559c-.56.19-1.21.21-1.36.49-2.74,5-6.54,5-11,2.56-.46-.26-1.3.09-1.94.26-1.1.29-2.18,1-3.25.95-7-.3-14-.79-21-1.14-5.64-.28-11.29-.47-16.94-.68a10.41,10.41,0,0,1-2.49,0c-8.63-2.54-17.9-3.94-25.65-8.12-6.94-3.75-13.88-7.66-20.87-11.4-11.06-5.92-22-5.44-33,.9-5.92,3.39-12.56,5.51-18.87,8.22-3.08,1.33-6,3.39-9.24,3.91-10.41,1.68-20.88,3.29-31.39,4-17.49,1.21-35,1.87-52.56,2.46-15.07.51-30.16.82-45.24.81-21.88,0-42.3-5.52-60.32-18.17-4.2-3-7.12-7.73-10.61-11.69a2.1,2.1,0,0,1-.65-1.32c.69-6,1-12.12,2.38-18,.65-2.87.78-4.79-1.08-7.18-7.07-9.06-6.84-16-.16-25.3a11.7,11.7,0,0,0,1.75-7.52c-1-9.34,2.5-17.16,7-24.85A13.72,13.72,0,0,0,19,442.13c.49-10.71-.44-21.26,3.47-31.94,3.22-8.81,3-18.84,4.56-28.29a29.52,29.52,0,0,1,2.67-7.47c5.11-10.89,5.6-22.77,7.46-34.35.25-1.57-.32-4.12-1.44-4.92-5.08-3.63-6.67-9-7.84-14.54-1.58-7.47-6.72-14.48-4-22.49,1-3,3.38-6.56,6.09-7.87,3.24-1.57,10.63,3.19,12,6.26,4.91,11,9.37,22.09,9,34.46,10.54-1.21,20.52-6.64,30.43,0,3.51-2.42,11.71-1.23,15,2.52,5.15,5.81,10,11.86,15,17.82,4.61,5.53,10,9.76,17.49,10.4a15.75,15.75,0,0,0,5.9-.36,176.36,176.36,0,0,0,51.69-26.51,27.47,27.47,0,0,1,4.06-2.77c4-2,5.41-4.87,5.61-9.49.75-16.84,7.68-31.4,17.86-44.56,2.44-3.16,6-4.12,9.41-2.6,7.65,3.45,15.39,6.94,22.44,11.43,8.25,5.26,15.81,11.61,23.67,17.48.54.4,1,1,1.65,1.1,9.66,1.65,15.77,9,23.18,14.28,2,1.42,4.43,2.24,6.67,3.31,1.2.57,3,.73,3.55,1.66,3.74,6.53,9.87,5.15,15.53,4.75,9.65-.67,15.49,4.54,21.16,11.56a43.82,43.82,0,0,0,14.61,11.68c8.73,4.19,15.69,10.5,23.4,16a133.07,133.07,0,0,0,35.27,18.27c9.88,3.25,19,8.64,28.76,12.4C457,404.62,471,409.36,484.9,414.19a23.28,23.28,0,0,0,6.85.83c13.29.36,26.62.21,39.89,1.06,8.73.56,17.39,2.43,26.06,3.86,12.74,2.11,22.35,7.8,25.58,21.53.7,3,3.51,5.46,5.45,8.1,4.39,5.94,4.29,13.16,4.87,19.86.93,10.82,2.22,22-4.1,32a16,16,0,0,1-1.92,2.87c-4.45,4.37-9.07,8.58-13.46,13s-9,7.83-15.38,8.74a11.22,11.22,0,0,0-5.64,2.88c-9.88,9.27-22.8,11.9-34.76,16.83-5.37,2.22-10.48,1.84-15.71,2.75-3.1.55-5.89,2.67-9,3.59-6.39,1.9-12.87,3.53-19.34,5.16a41.42,41.42,0,0,1-6.83,1.13C465,558.55,462.43,558.4,459.07,558.4Zm-279.6-9.3,7.47.72c1.92-.25,4-.09,5.74-.81,10.07-4.15,20.39-7.86,30-12.93,19.79-10.47,38.84-11.62,58,1.32a158.86,158.86,0,0,0,23.63,13.41c8.92,4,18.8,3.06,28.41,3.25a95.93,95.93,0,0,0,34.8-5.2c9.49-3.39,19.1-6.5,28.71-9.54a8.21,8.21,0,0,1,9.37,2.59c4.27,4.81,8.23,4.15,12.17-.94,2.17-2.81,5-7,7.69-7.17a136.22,136.22,0,0,1,28.19,1c7.21,1.09,14,4.69,21.13,6.69,7.77,2.19,15.58,3.49,23.82,1.63,16.28-3.68,31.42-10.12,46.35-17.35,12.75-6.16,24.57-13.56,34.95-23.26a20.88,20.88,0,0,0,6.86-14.88c.12-3.11-1.65-6.27-1.69-9.42a115,115,0,0,1,1-15.28c.62-5,1.48-9.8-3.15-13.73-1.51-1.27-2.42-3.64-2.88-5.67-2.83-12.73-11.66-18.63-23.65-20.32-15.55-2.19-31-5.26-46.91-4.34-6.32.36-12.67.07-19,0a21.36,21.36,0,0,1-4.45-.4c-15.81-3.56-30.22-11-45.36-16.46-10.57-3.8-21.09-7.87-31.3-12.56-9.09-4.17-17.72-9.34-26.53-14.12-7.44-4-14.85-8.16-22.07-12.13l-4.28,4c-2.24-2-4.22-3.84-6.34-5.53a12.7,12.7,0,0,0-4.34-2.7c-4-1.05-8.08-1.68-12.93-2.64,2.58-3.62,4.16-5.84,6-8.36-1.8-2.17-3.39-5.58-6.05-7a67.32,67.32,0,0,0-14.84-5.2c-4.46-1.13-9.33-.87-13.66-2.31-5.29-1.75-10.24-4.55-15.21-7.15-.5-.26-.06-2.32-.06-3.68-4.37-2.5-7.17-9.36-14.29-6-.1,0-.29-.16-.45-.2-7-1.93-13.93-3.88-20.91-5.77-7.83-2.11-15.87-1.56-22.56,2.43-10.6,6.32-20.4,14-30.55,21.08-15.19,10.61-29.9,22.16-47.9,27.78-12.5,3.91-24.83,9.41-38.42,7.57-4.55-.61-8.9-1.2-13,1.3-10.7,6.58-21.34,13.26-32.61,20.27L50.6,383.8l43.89-20.05c-9.7-6.93-12.75-17.55-16.59-27.85-.76-2.06-3.83-3.94-6.18-4.52s-5.2,1-7.79.85c-12.84-.69-18.31,9.28-23.44,17.76-3.7,6.1-3.79,14.39-5.5,21.72L32.5,377q-1.8,7.31-3.62,14.61L26.7,402c.69,1.34,1,3.23,2.13,3.91,5.27,3.26,10.74,6.19,16.15,9.24a2.58,2.58,0,0,1,0,.83l-21.42,7.26c-.4,7.46-.7,14.23-1.19,21A32.21,32.21,0,0,1,21,449.57L17,457.33,15,460.63l-.92,14.54-2.14,9.1c5.56,4.37,10.86,9.15,16.75,13,9.61,6.32,19.61,12,29.43,18,7.35,4.48,15.07,2.24,21.48-.9,8.43-4.12,15.29-1.94,22.58,1.61-1.29.07-2.59.22-3.88.18-6-.18-12-1-17.89-.44-4.44.41-8.65,3-13.1,3.75-10.08,1.75-17.45-4.4-25.1-9.45-6.67-4.4-13.16-9.08-20-13.26-1.62-1-4.17-.5-6.29-.68l-.08.94-4.38-2.6-1.2.84c.47,2.66.14,5.95,1.6,7.86,2.69,3.53,3.46,6.81,1.84,10.81q-.64,5.53-1.3,11.08c.25,2.23-.33,5.28.91,6.55a61.6,61.6,0,0,0,11.85,9.57c13.09,7.94,28,10.9,42.78,11.34,29,.86,58.07.26,87.1-.24C163.23,552.12,171.34,550.2,179.47,549.1ZM41.88,336.67l1.2-.37c.23-2.09.9-4.24.61-6.25-1.43-10-3-19.94-4.85-29.83-.31-1.63-2.43-3.92-3.89-4.07-1.63-.16-4.56,1.44-5,2.87-1.08,3.45-2.41,7.81-1.19,10.8C32.52,319,37.42,327.76,41.88,336.67Zm195.84-50.16c-2.78-.53-4.77-.79-6.69-1.29-1.41-.38-3.12-.72-4.05-1.69-3.26-3.44-7.34-3.37-9.69.75-3.06,5.39-5.78,11-8.11,15.43l17.53,3.69Zm-36.4,36.32c8.4-6,17.79-9,24.42-16.85C206.22,297.53,200.93,304.86,201.32,322.83Z"
      transform="translate(-3.52 -274.72)"
      fill="#080709"
    />
    <path
      d="M102.18,516c-7.29-3.55-14.15-5.73-22.58-1.61-6.41,3.14-14.13,5.38-21.48.9-9.82-6-19.82-11.69-29.43-18-5.89-3.87-11.19-8.65-16.75-13,.8-3.38,1.47-6.24,2.14-9.11,2.31-.55,4.62-1.52,6.93-1.53s4.92.91,7.38,1.42l.37-1.56a33.09,33.09,0,0,0-4.71-2.31c-8.27-2.6-8.28-2.56-9-10.55l1.95-3.3L37.26,459l-14.39-5,.15-1.84,8.14-3.69-.15-.56-10,1.68a32.21,32.21,0,0,0,1.28-5.37c.49-6.76.79-13.53,1.19-21L44.93,416,46,417c1,1.18,1.8,2.71,3.05,3.48,9.74,6,19.6,11.75,29.36,17.69C83,441,87.45,444.08,92,447l3.09,3,1-1.56-4-1.5c-2.92-2.76-5.56-5.91-8.82-8.18-4.33-3-9.21-5.24-13.75-8-5.55-3.37-11-7-16.5-10.36-2.2-1.34-4.61-2.33-6.93-3.48L45,415.12c-5.41-3.05-10.88-6-16.15-9.24-1.1-.68-1.44-2.57-2.13-3.91,7.14-2.11,3.42-6.51,2.18-10.38q1.82-7.3,3.62-14.61a20.91,20.91,0,0,1,3,2.16c1.6,1.66,2.69,4.1,4.59,5.1,3.76,2,7.92,3.24,11.92,4.79l24.9,11.21.7-1.76L52.05,389c-3.14-1.89-6.14-4.11-9.46-5.58-5.22-2.31-7.64-6.1-7.6-11.67,1.71-7.32,1.8-15.61,5.5-21.71,5.13-8.48,10.6-18.45,23.44-17.76,2.59.14,5.41-1.44,7.79-.85s5.42,2.46,6.18,4.52c3.84,10.3,6.89,20.92,16.59,27.85L50.6,383.8l17.83,7.39c11.27-7,21.91-13.69,32.61-20.27,4.07-2.5,8.42-1.91,13-1.3,13.59,1.84,25.92-3.66,38.42-7.57,18-5.62,32.71-17.17,47.9-27.78,10.15-7.09,19.95-14.76,30.55-21.08,6.69-4,14.73-4.54,22.56-2.43,7,1.89,13.94,3.84,20.91,5.77.16,0,.35.25.45.2,7.12-3.35,9.92,3.51,14.29,6,0,1.36-.44,3.42.06,3.68,5,2.6,9.92,5.4,15.21,7.15,4.33,1.44,9.2,1.18,13.66,2.31a67.32,67.32,0,0,1,14.84,5.2c2.66,1.4,4.25,4.81,6.05,7-1.81,2.52-3.39,4.74-6,8.36,4.85,1,8.95,1.59,12.93,2.64a12.7,12.7,0,0,1,4.34,2.7c2.12,1.69,4.1,3.56,6.34,5.53l4.28-4c7.22,4,14.63,8.09,22.07,12.13,8.81,4.78,17.44,9.95,26.53,14.12,10.21,4.69,20.73,8.76,31.3,12.56,15.14,5.45,29.55,12.9,45.36,16.46a21.36,21.36,0,0,0,4.45.4c6.33,0,12.68.33,19,0,15.87-.92,31.36,2.15,46.91,4.34,12,1.69,20.82,7.59,23.65,20.32.46,2,1.37,4.4,2.88,5.67,4.63,3.93,3.77,8.7,3.15,13.73a115,115,0,0,0-1,15.28c0,3.15,1.81,6.31,1.69,9.42a20.88,20.88,0,0,1-6.86,14.88c-10.38,9.7-22.2,17.1-34.95,23.26-14.93,7.23-30.07,13.67-46.35,17.35-8.24,1.86-16.05.56-23.82-1.63-7.12-2-13.92-5.6-21.13-6.69a136.22,136.22,0,0,0-28.19-1c-2.72.16-5.52,4.36-7.69,7.17-3.94,5.09-7.9,5.75-12.17.94a8.21,8.21,0,0,0-9.37-2.59c-9.61,3-19.22,6.15-28.71,9.54a95.93,95.93,0,0,1-34.8,5.2c-9.61-.19-19.49.73-28.41-3.25a158.86,158.86,0,0,1-23.63-13.41c-19.2-12.94-38.25-11.79-58-1.32-9.6,5.07-19.92,8.78-30,12.93-1.73.72-3.82.56-5.74.81l-8.5-3.84a3.29,3.29,0,0,1-.59-.47l-5.43-2.57a2.67,2.67,0,0,1-.57-.43l-6.43-2.57a2.83,2.83,0,0,1-.56-.42L160.08,538c-2.43-.92-4.93-1.7-7.29-2.78-7.06-3.21-14.06-6.53-21.09-9.8l-5.28-.24ZM299,464h0l1-1h0l1.08-.84.78-2.46,4.38-4.47,2-2.14.88-.88,1.12-1.13L311,450l4.25-4.89L316,444c1.81-2.11,3.65-4.19,5.42-6.33,4.59-5.51,9.14-11,13.71-16.56l2-2,6.26-8c2.48-.85,3.94-2.19,3.31-4.75l-5.54,1.56-1.22-.2a2.57,2.57,0,0,0-.59-.5l-16.47-8.81L310,415.23,297.19,432l-1-.66-1-12.4c.32-.09.91-.18.91-.26-.33-10-.64-19.92-1.21-29.86,0-.7-1.93-1.3-3-1.94a1.52,1.52,0,0,1-.94-.09l-16.73-10.4-7,9.85h.07L266.12,388l-36,44-2.29,2.69h-1.71L232,424l2.85-2L233.62,421,232,424q-4,5-8,9.94l0,0-1.55,1.3,1.54.84c5.08,2.12,10.34,3.91,15.2,6.44,6.92,3.61,8.61,3.35,13.58-3.15,2.24-2.94,4.86-5.6,7.31-8.39.13.19.25.37,0,0,.31.23.13.1-.05,0l1-2,1.84-.33-1.61-.72.14-1.79c1.42-1.08,2.9-2.09,4.26-3.25,1.79-1.53,3.48-3.18,5.22-4.78l1.06,9.82a1.38,1.38,0,0,0-.78,0l-.91-1.72-.85.62,1.63,1.25.69,1q0,9.42,0,18.86c-.11.11-.33.25-.31.33a4.67,4.67,0,0,0,.31.81c.08,1,.17,2,.25,2.94.49,1.8-3,5.23,2.1,5.14l4.89,2.18,8.11,2.82,3.89,1.2c3.16,3.33,5.09,3.77,7.1,1.63h0Zm-186,1c.34.3.68.6.09.07.81.18.34.08-.13,0-.09-.46-.19-.91,0-.13C112.42,464.3,112.72,464.64,113,465Zm270,21,1.65-1.2-.78-.63L383,486l-2.25.25.14.73ZM33.05,405l-1.23-1.61-.66.76L33,405l3.22,1.87.51-1.43ZM108,460l1.22,1.61.64-.76-1.78-.93-2-2.84-1,1.28Zm282.08,21,5-3,7-3,4-3a29,29,0,0,0,4.2-1.19c8.83-3.94,17.61-8,27.72-5.83l33.22,15.68.74-1.56c-8.22-4.06-16.35-8.3-24.69-12.1-2.8-1.27-6.11-1.43-9.19-2.1-.77-.59-1.49-1.61-2.33-1.71-11.16-1.41-20.59,3.21-29.75,8.73l-4,3-7,3-5,3-3.84,1.72,2,2.36ZM379,401l-.48-.42-.09.1.5.39c-.31,1.31-.63,2.61-1,4.3l16.26,12.44.16-.37ZM238,363c-6.67,1-13.41,1.69-20,3.14-10.44,2.31-20.91,4.73-30,10.92L170.3,384.5l.83,1.7L188,377a3.32,3.32,0,0,0,1,0,189.33,189.33,0,0,1,47.71-12.15c.52-.06.91-1.16,1.36-1.77l.46-.44,0-.05Zm42-9-.48-.42-.09.09.5.4,7.65,5.79L286,361c-1.76-.35-3.52-1-5.27-1-9.42.22-18.83.5-28.23,1-4.06.22-8.09,1-12.13,1.58a3.69,3.69,0,0,0,2.92,1.31q19.77-.94,39.53-2a13.25,13.25,0,0,0,3.14-1,42.34,42.34,0,0,1,6.47,1.67c8.26,3.53,16.43,7.27,24.66,10.86,1.8.78,3.73,1.25,5.6,1.85A3,3,0,0,0,321,373c-9.56-4.7-19.09-9.46-28.71-14C288.31,357.11,284.12,355.63,280,354Zm-9.47-24a2.6,2.6,0,0,1-.68-.6c.74-3.28,1.48-6.55,2.24-9.88-15.45-5.42-24.7-5.92-29.43-1.08,11.92,9.67,25.6,15.56,41,21.45a48.77,48.77,0,0,1-1.62-5.51,30.41,30.41,0,0,1-.05-4.29C275.39,333.71,275,333.71,270.55,330ZM137.9,507.27l.35-1.84L65.89,485.16l-.45,
      1.54C89,495.73,113.7,500.57,137.9,507.27ZM288,
      500.62l-35.87-4.95,0,.49,46.22,9.33.21-.6-10.85-3.38A7.57,7.57,0,1,
      1,288,500.62Zm11.09-114.07-2.17,0,1.28,24,.89-.09ZM429.9,412.81v.81l14.49.8,5.26-3.51ZM219.72,490l-.37.8-13.3-.77L206,491.2l21.46,2c0-.69,0-1.38,0-2.07-1.11.24-2.28.83-3.31.64A23.4,23.4,0,0,1,219.72,490Zm-95.86-16.83.27-.88-6.73-4.5-7.8,1.84Zm240.22-78,.84-1.46-18.06-9.05-.79,1.55ZM44.17,477.51,44,479l17,5.11.33-1.14Zm288.89,34.55.19-1.51-16-1.83-.15,1.27ZM245,409.12l-1.14-.84-5.88,7.52,1.13.86Q242,412.9,245,409.12Zm32.42-54.48.85-1.47-4.08-1.95c-.21.43-.43.85-.64,1.28Zm-178,99.94,1.44-1.45-1.2-2.67-1.47,1.48ZM236.66,419c-.17-.25-.31-.65-.51-.68s-.53.23-.8.37l.71.95Zm141,69.35.13.57,1.4-.34-.13-.52Zm-3,1.92.05.57,1.54-.18-.05-.55ZM372,493.18c-.13.08-.3.13-.35.25s.12.22.18.34l.55-.43Z"
      transform="translate(-3.52 -274.72)"
      className="white-fill"
    />
    <path
      d="M102.18,516l24.24,9.14,5.28.24c7,3.27,14,6.59,21.09,9.8,2.36,1.08,4.86,1.86,7.29,2.78l4.78,1.55a2.83,2.83,0,0,0,.56.42l6.43,2.57a2.67,2.67,0,0,0,.57.43l5.43,2.57a3.62,3.62,0,0,0,.58.47c.35,1,.7,2.08,1,3.12-8.13,1.1-16.24,3-24.39,3.16-29,.5-58.09,1.1-87.1.24-14.79-.44-29.69-3.4-42.78-11.34a61.6,61.6,0,0,1-11.85-9.57c-1.24-1.27-.66-4.32-.91-6.54.92-.79,1.83-1.61,2.85-2.51l5.72,5,.65-.68L13.74,514c1.62-4,.85-7.28-1.84-10.81-1.46-1.91-1.13-5.2-1.6-7.86l1.2-.84,4.38,2.6.08-.94c2.12.18,4.67-.32,6.29.68,6.8,4.18,13.29,8.86,20,13.26,7.65,5.05,15,11.2,25.1,9.45,4.45-.78,8.66-3.34,13.1-3.75,5.9-.54,11.92.26,17.89.44C99.59,516.23,100.89,516.08,102.18,516ZM77.61,540c12.73-5.14,25.38-.91,38.08.67C103.13,535.24,90.52,532.64,77.61,540Z"
      transform="translate(-3.52 -274.72)"
      fill="#a8a8a7"
    />
    <path
      d="M237.72,286.51l-11,16.89-17.53-3.69c2.33-4.46,5-10,8.11-15.43,2.35-4.12,6.43-4.19,9.69-.75.93,1,2.64,1.31,4.05,1.69C233,285.72,234.94,286,237.72,286.51ZM225,291.87c2.93-.2,3.32-.78,2.12-3.2-1.56-3.06-2.92-2-4.23.2l-1.64,1.7Z"
      transform="translate(-3.52 -274.72)"
      className="white-fill"
    />
    <path
      d="M201.32,322.83c-.39-18,4.9-25.3,24.42-16.85C219.11,313.82,209.72,316.79,201.32,322.83Z"
      transform="translate(-3.52 -274.72)"
      className="white-fill"
    />
    <path
      d="M21,449.57l10-1.68.15.56L23,452.14,22.87,454l14.39,5L17,457.33Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M13.74,514l7.92,12.94-.65.68-5.72-5c-1,.9-1.93,1.72-2.85,2.51Q13.09,519.49,13.74,514Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M15,460.63c.77,8,.78,7.95,9.05,10.55a33.09,33.09,0,0,1,4.71,2.31l-.37,1.56c-2.46-.51-4.92-1.43-7.38-1.42s-4.62,1-6.93,1.53Q14.55,467.9,15,460.63Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M52,389c-4-1.55-8.16-2.79-11.92-4.79-1.9-1-3-3.44-4.59-5.1a20.91,20.91,0,0,0-3-2.16L35,371.7c0,5.57,2.38,9.36,7.6,11.67,3.32,1.47,6.32,3.69,9.46,5.58Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M28.88,391.59c1.24,3.87,5,8.27-2.18,10.38Q27.8,396.78,28.88,391.59Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M179.47,549.1c-.34-1-.69-2.08-1-3.12l8.51,3.84Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M45,415.12c.35.61.71,1.22,1.07,1.83L46,417l-1-1.08A2.58,2.58,0,0,0,45,415.12Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M339.29,407.23a2.57,2.57,0,0,1,.59.5c-4.12,5.43-8.16,10.92-12.38,16.26-6.1,7.72-12.34,15.33-18.52,23l-2.58,3L306,450l-.07.38L301.4,456,301,456l-.07.38-1.79,2.52-2,2.49L277,454c-.27-1.75-.69-3.49-.79-5.25-.48-9.23-.89-18.46-1.32-27.7l-1.56-10-1.85-.41c-1.45,2.11-2.89,4.23-4.34,6.35l-6.33,7.51c-3.81,4.3-7.94,8.36-11.32,13-2,2.7-3.44,3.32-6.41,1.9-4.27-2.06-8.74-3.7-13.12-5.53l.15-1.87,36-44,1.22-1.75h-.07a19.89,19.89,0,0,0,3.28-2.81c2.46-3.32,5.09-4,8.87-1.89s7.69,3.52,11.55,5.25a1.55,1.55,0,0,0,.95.09c.7,1.47,1.93,2.91,2,4.41.56,9.21.86,18.43,1.24,27.65l1,12.4,1,.66L310,415.23c1.31-.89,2.87-1.55,3.88-2.69,3.39-3.81,6.58-7.79,9.58-11.39Z"
      transform="translate(-3.52 -274.72)"
      fill="#080709"
    />
    <path
      d="M270.55,330c4.42,3.69,4.84,3.69,11.46.09a30.41,30.41,0,0,0,.05,4.29,48.77,48.77,0,0,0,1.62,5.51c-15.4-5.89-29.08-11.78-41-21.45,4.73-4.84,14-4.34,29.43,1.08-.76,3.33-1.5,6.6-2.24,9.88l-2,1.09,1.78,1.58Z"
      transform="translate(-3.52 -274.72)"
      fill="#080709"
    />
    <path
      d="M277,454l20.09,7.41,2-2.49,1.78,0,.9.73-.78,2.46L300,463h0l-1,1h0l-1,1h0l-5.16-2.37-1.94.74-3.89-1.2-8.11-2.82L274,457.15l-2.1-5.14c-.08-1-.17-2-.25-2.94v-1.14q0-9.44,0-18.86c.07-.38.15-.77.22-1.15-.35-3.27-.71-6.54-1.06-9.82L267.18,417c1.45-2.12,2.89-4.24,4.34-6.35l1.85.41,1.56,10c-.28.38-.81.76-.8,1.13.26,10.07.55,20.14,1,30.21C275.12,453,276.37,453.46,277,454Z"
      transform="translate(-3.52 -274.72)"
      fill="#a8a8a7"
    />
    <path
      d="M309,447c6.18-7.66,12.42-15.27,18.52-23,4.22-5.34,8.26-10.83,12.38-16.26l1.22.2c.75,1.06,1.49,2.12,2.23,3.19l-6.26,8-2,2c-4.57,5.52-9.12,11.05-13.71,16.56-1.77,2.14-3.61,4.22-5.42,6.33l-.75,1.1L311,450l-1,0-.61-.62Z"
      transform="translate(-3.52 -274.72)"
      fill="#a8a8a7"
    />
    <path
      d="M230,433.85c4.38,1.83,8.85,3.47,13.12,5.53,3,1.42,4.44.8,6.41-1.9,3.38-4.62,7.51-8.68,11.32-13l.48,1.63-.14,1.79c-.08.35-.16.7-.23,1.05l-1,2h0c-2.45,2.79-5.07,5.45-7.31,8.39-5,6.5-6.66,6.76-13.58,3.15-4.86-2.53-10.12-4.32-15.2-6.44,0-.72,0-1.43,0-2.14l0,0,2.22.78h1.71Z"
      transform="translate(-3.52 -274.72)"
      fill="#a8a8a7"
    />
    <path
      d="M137.9,507.27c-24.2-6.7-48.95-11.54-72.46-20.57l.45-1.54,72.36,20.27Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M92,447c-4.52-2.95-9-6-13.59-8.83-9.76-5.94-19.62-11.72-29.36-17.69-1.25-.77-2-2.3-3.05-3.48l.08-.08c2.32,1.15,4.73,2.14,6.93,3.48,5.55,3.38,11,7,16.5,10.36,4.54,2.74,9.42,5,13.75,8,3.26,2.27,5.9,5.42,8.82,8.18Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M286,361l1.57-1.21L280,354,280,354c4.1,1.66,8.29,3.14,12.28,5,9.62,4.57,19.15,9.33,28.71,14a3,3,0,0,1,1.71,2.33c-1.87-.6-3.8-1.07-5.6-1.85-8.23-3.59-16.4-7.33-24.66-10.86A42.34,42.34,0,0,0,286,361Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M238.05,363c-.45.61-.84,1.71-1.36,1.77A189.33,189.33,0,0,0,189,377a3.32,3.32,0,0,1-1,0l.05,0c9.06-6.19,19.53-8.61,30-10.92,6.57-1.45,13.31-2.12,20-3.14Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M438.05,465c3.08.67,6.39.83,9.19,2.1,8.34,3.8,16.47,8,24.69,12.1l-.74,1.56L438,465Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M288,500.62a7.57,7.57,0,1,0-.33.89l10.85,3.38-.21.6-46.22-9.33,0-.49Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M286,361a13.25,13.25,0,0,1-3.14,1q-19.75,1.08-39.53,2a3.69,3.69,0,0,1-2.92-1.31c4-.55,8.07-1.36,12.13-1.58,9.4-.51,18.81-.79,28.23-1,1.75,0,3.51.63,5.27,1Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M339.29,407.23l-15.87-6.08c-3,3.6-6.19,7.58-9.58,11.39-1,1.14-2.57,1.8-3.88,2.69l12.86-16.81Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M291,386.82c-3.86-1.73-7.89-3.17-11.55-5.25s-6.41-1.43-8.87,1.89a19.89,19.89,0,0,1-3.28,2.81l7-9.85Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M438,465c-10.11-2.18-18.89,1.89-27.72,5.83a29,29,0,0,1-4.2,1.19L406,472c9.16-5.52,18.59-10.14,29.75-8.73.84.1,1.56,1.12,2.33,1.71Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M295.18,419c-.38-9.22-.68-18.44-1.24-27.65-.09-1.5-1.32-2.94-2-4.41,1,.64,2.92,1.24,3,1.94.57,9.94.88,19.9,1.21,29.86C296.09,418.79,295.5,418.88,295.18,419Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M299.07,386.55V410.5l-.89.09-1.28-24Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M379,401l15.31,16.44-.16.37-16.26-12.44c.41-1.69.73-3,1-4.3Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M52.05,389l25.53,9.53-.7,1.76L52,389Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M429.9,412.81l19.75-1.9-5.26,3.51-14.49-.8Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M219.72,490a23.4,23.4,0,0,0,4.38,1.72c1,.19,2.2-.4,3.31-.64,0,.69,0,1.38,0,2.07l-21.46-2,.06-1.16,13.3.77Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M123.86,473.18l-14.26-3.54,7.8-1.84,6.73,4.5Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M364.08,395.21l-18-9,.79-1.55,18.06,9.05Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M188,377l-16.85,9.22-.83-1.7L188,377Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M44.17,477.51,61.31,483,61,484.15,44,479Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M333.06,512.06l-16-2.07.15-1.27,16,1.83Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M261.33,426.13l-.48-1.63,6.33-7.51,3.63,1.11c-1.74,1.6-3.43,3.25-5.22,4.78C264.23,424,262.75,425.05,261.33,426.13Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M226.15,434.67l-2.22-.78q4-5,8-9.94l.08.08Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M245,409.12q-2.94,3.78-5.89,7.54l-1.13-.86,5.88-7.52Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M343.33,411.12c-.74-1.07-1.48-2.13-2.23-3.19l5.54-1.56C347.27,408.93,345.81,410.27,343.33,411.12Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M278.87,459.33l8.11,2.82Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M290.87,463.35l1.94-.74L298,465C296,467.12,294,466.68,290.87,463.35Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M306,450.4,306,450l.38-.07,3-.59.61.62c.07.36.13.71.2,1.07l-1.12,1.13-.88.88-2,2.14-.86-.82C305.56,453.06,305.75,451.73,306,450.4Z"
      transform="translate(-3.52 -274.72)"
      fill="#a8a8a7"
    />
    <path
      d="M301,456.4,301,456l.38-.07,4-1.57.86.82-4.38,4.47-.9-.73C301,458.09,301,457.25,301,456.4Z"
      transform="translate(-3.52 -274.72)"
      fill="#a8a8a7"
    />
    <path
      d="M277.37,354.64l-3.87-2.14c.21-.43.43-.85.64-1.28l4.08,1.95Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M271.88,452l2.1,5.14C268.84,457.24,272.37,453.81,271.88,452Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M171.85,542.51l-6.43-2.57Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M92.05,447l4,1.5-1,1.56L92,447Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M395,478l7-3,.08.08-7,3Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M395.05,478.05l-5,3L390,481l5-3Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M390.05,481.05l-2,4-2-2.36L390,481Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M164.86,539.52,160.08,538Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M177.85,545.51l-5.43-2.57Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M406.05,472.05l-4,3L402,475l4-3Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M99.41,454.58l-1.23-2.64,1.47-1.48,1.2,2.67Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M232,424l1.67-3,1.26,1.07L232,424Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M108,460l-3-1.64,1-1.28,2,2.84Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M33.05,405l3.65.52-.51,1.43L33,405Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M131.7,525.39l-5.28-.24Z"
      transform="translate(-3.52 -274.72)"
      fill="#080709"
    />
    <path
      d="M108.05,460l1.78.93-.64.76c-.4-.54-.81-1.07-1.22-1.61Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M236.66,419l-.6.64-.71-.95c.27-.14.56-.4.8-.37S236.49,418.75,236.66,419Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M383,486l.94-1.75.78.63L383,486Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M223.9,433.93c0,.71,0,1.42,0,2.14l-1.54-.84Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M33,405l-1.81-.93.66-.76L33.05,405Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M230,433.85l-2.14.82,2.29-2.69Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M335.1,421.07l2-2Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M271,428.05l-1.63-1.25.85-.62c.3.58.6,1.15.91,1.72Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M383,486l-2.18.9-.14-.73L383,486Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M377.68,488.35l1.4-.29.13.52-1.4.34Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M374.65,490.27l1.54-.16.05.55-1.54.18Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M261,429c.07-.35.15-.7.23-1.05l1.61.72Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M372,493.18l.38.16-.55.43c-.06-.12-.21-.27-.18-.34S371.86,493.26,372,493.18Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M113,465c-.29-.34-.59-.68-.06-.08-.17-.78-.07-.33,0,.13Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M113,465c.47.1.94.2.13,0,.59.53.25.23-.09-.07Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M267.34,386.27,266.12,388Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M260,431c.18.13.36.26.05,0,.22.33.1.15,0,0Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M271.87,427.92c-.07.38-.15.77-.22,1.15l-.69-1,.13-.15A1.38,1.38,0,0,1,271.87,427.92Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M271.63,447.93v1.14a4.67,4.67,0,0,1-.31-.81C271.3,448.18,271.52,448,271.63,447.93Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M310.18,451.05c-.07-.36-.13-.71-.2-1.07l1,0Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M238,363l.48-.42,0,.05-.46.44Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M300,463l1.08-.84Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M299,464l1-1Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M298,465l1-1Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M308.18,453.06l.88-.88Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M379,401l-.5-.39.09-.1.48.42Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M280,354l-.5-.4.09-.09.48.42Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M315.22,445.06,316,444Z"
      transform="translate(-3.52 -274.72)"
      fill="#c9c9c9"
    />
    <path
      d="M77.61,540c12.91-7.34,25.52-4.74,38.08.67C103,539.07,90.34,534.84,77.61,540Z"
      transform="translate(-3.52 -274.72)"
      fill="#080709"
    />
    <path
      d="M222.88,288.87c1.31-2.2,2.67-3.26,4.23-.2L225,291l.09.07L223,289Z"
      transform="translate(-3.52 -274.72)"
      fill="#080709"
    />
    <path
      d="M225,291.87l-3.75-1.3,1.64-1.7.08.09,2.09,2.09L225,291A2.22,2.22,0,0,1,225,291.87Z"
      transform="translate(-3.52 -274.72)"
      fill="#080709"
    />
    <path
      d="M225,291.87a2.22,2.22,0,0,0,0-.89l2.15-2.31C228.31,291.09,227.92,291.67,225,291.87Z"
      transform="translate(-3.52 -274.72)"
      fill="#a8a8a7"
    />
    <path
      d="M270.55,330l-.93,2.07-1.78-1.58,2-1.09A2.6,2.6,0,0,0,270.55,330Z"
      transform="translate(-3.52 -274.72)"
      fill="#a8a8a7"
    />
    <path
      d="M225.05,291.05,223,289Z"
      transform="translate(-3.52 -274.72)"
      fill="#a8a8a7"
    />
  </svg>
);

export default NewBalance608;
